function localStorageAvailable(): boolean {
  return typeof window === 'object' && typeof Storage === 'function';
}

export function setItem(
  name: string,
  value: string,
  json: false,
): boolean | undefined;
export function setItem(
  name: string,
  value: unknown,
  json?: true,
): boolean | undefined;
export function setItem(name: string, value: unknown, json = true) {
  if (!localStorageAvailable()) return undefined;

  try {
    const storedValue = json ? JSON.stringify(value) : String(value);
    window.localStorage.setItem(name, storedValue);
  } catch {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
}

export function getItem(name: string): unknown {
  if (!localStorageAvailable()) return undefined;
  let item;

  try {
    item = window.localStorage.getItem(name);
  } catch {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  if (item == null) return item;

  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
}

export function hasItem(name: string): boolean {
  if (!localStorageAvailable()) return false;

  try {
    return window.localStorage.getItem(name) != null;
  } catch {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return false;
  }
}

export function removeItem(name: string): boolean | null | undefined {
  if (!localStorageAvailable()) return undefined;

  try {
    window.localStorage.removeItem(name);
  } catch {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
}
